import IconAsMaskImage from "../IconAsMaskImage";

function Delete({ pureSvg, className, size, color, ...rest }) {
  const svg = (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle cx="10.5" cy="10.5" r="10.5" fill="#C26262" fillOpacity="0.12" />
      <path
        d="M7.26953 7.26953L13.7311 13.7311"
        stroke="#C91616"
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7311 7.26953L7.26953 13.7311"
        stroke="#C91616"
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, size, color }} />;
}

export default Delete;
